export const formatRows = (listaItems, tipooferta) =>
  listaItems.map((item) => {
    
    let cod= item["oferta_Art"]?.art_codigo;
    let desc= item["oferta_Art"]?.art_descripcion;
    return {
      id: item.id,
      art_codigo: cod,
      art_descripcion: desc, // Verifica si oferta_Art existe
      aofd_art_nprecio: item.aofd_art_nprecio,
      aofd_ofertaprecio: item.aofd_ofertaprecio,
      ...(Number(tipooferta) === 1 ? { aofd_ofertastock: item.aofd_ofertastock } : {}),
      web: item.aofd_show_web === 0 ? "✅" : "❌",
      app: item.aofd_show_app  === 0 ? "✅" : "❌",
    };

  });
